export enum DocumentPartyVisibility {
    AdminOnly = 0,
    Seller = 1,
    SellerAndBuyer = 2,
}

export const DocumentPartyVisibilityOptions = {
    [DocumentPartyVisibility.AdminOnly]: 'Admin only',
    [DocumentPartyVisibility.Seller]: 'Seller',
    [DocumentPartyVisibility.SellerAndBuyer]: 'Seller and Buyer',
};

export const DocumentPartyVisibilityOptionsMapping = [
    {
        value: DocumentPartyVisibility.AdminOnly,
        label: DocumentPartyVisibilityOptions[
            DocumentPartyVisibility.AdminOnly
        ],
    },
    {
        value: DocumentPartyVisibility.Seller,
        label: DocumentPartyVisibilityOptions[
            DocumentPartyVisibility.Seller
        ],
    },
    {
        value: DocumentPartyVisibility.SellerAndBuyer,
        label: DocumentPartyVisibilityOptions[
            DocumentPartyVisibility.SellerAndBuyer
        ],
    },
];
